var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15a1 1 0 110 2 1 1 0 010-2zM15 15a1 1 0 110 2 1 1 0 010-2zM18 15a1 1 0 110 2 1 1 0 010-2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.102 4.005A1 1 0 0122 5v14a1 1 0 01-.898.995L21 20H3a1 1 0 01-1-1V5a1 1 0 011-1h18l.102.005zM3.5 18.5h17V10h-17v8.5zM3.5 8h17V5.5h-17V8z",
    fill: "currentColor"
  })));
}
SvgCvv.displayName = 'Cvv';
export default SvgCvv;